/**
 * Wiki Module Routes Configuration
 * Defines all routes for the wiki/knowledge base module
 */

import React from 'react';
import type { RouteObject } from 'react-router-dom';
import Layout from '../../../../components/Layout';
import PrivateRoute from '../../../../components/PrivateRoute';

// Pages
import ArticleDetail from '../pages/ArticleDetail';
import ArticleCreate from '../pages/ArticleCreate';
import ArticleEdit from '../pages/ArticleEdit';
import DepartmentDetail from '../pages/DepartmentDetail';
import CuratorInbox from '../pages/CuratorInbox';
import DSWikiMasters from '../pages/DSWikiMasters';

// Master Components
import ArticleTypeManagement from '../masters/article-type';
import ArticleCategoryManagement from '../masters/article-category';
import WorkspaceManagement from '../masters/workspace';

/**
 * Wiki route configuration
 * Routes for DS Wiki knowledge base module
 */
export const wikiRoutes: RouteObject[] = [
  {
    path: '/app/ds-wiki',
    element: <PrivateRoute><Layout /></PrivateRoute>,
    children: [
      {
        index: true,
        element: <DepartmentDetail />
      },
      {
        path: 'articles',
        element: <DepartmentDetail />
      },
      {
        path: 'articles/create',
        element: <ArticleCreate />
      },
      {
        path: 'articles/:articleId',
        element: <ArticleDetail />
      },
      {
        path: 'articles/:articleId/edit',
        element: <ArticleEdit />
      },
      {
        path: 'departments/:departmentId',
        element: <DepartmentDetail />
      },
      {
        path: 'curator-inbox',
        element: <CuratorInbox />
      },
      {
        path: 'masters',
        element: <DSWikiMasters />
      },
      // Individual Master Routes
      {
        path: 'masters/article-types',
        element: <ArticleTypeManagement />
      },
      {
        path: 'masters/article-categories',
        element: <ArticleCategoryManagement />
      },
      {
        path: 'masters/workspaces',
        element: <WorkspaceManagement />
      }
    ]
  }
];

export default wikiRoutes;
